import React from 'react';
import { toPlainText } from '../utils/plainText';

const RESULT_CLASS = {
  win: 'result-won',
  won: 'result-won',
  lost: 'result-lost',
  void: 'result-void',
  voided: 'result-void',
};

export default function NotificationMessage({ message }) {
  const parts = toPlainText(message).split(/\b(win|won|lost|void|voided)\b/gi);

  return parts.map((part, index) => {
    const resultClass = RESULT_CLASS[part.toLowerCase()];
    return resultClass ? (
      <span key={`${part}-${index}`} className={resultClass}>{part}</span>
    ) : (
      <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
    );
  });
}
